import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { EmptySetting, IReqPublishSetting } from "./ReqPublishSetting";
import { JVDropdown } from "../../shared/JVDropdown";
import { IBranchMastDropdown, ICompanyMastDropdown, IRolesDropdown } from "../../models/IDropdown";
import { JVCheckbox } from "../../shared/JVCheckbox";

const schema = yup.object({
    roleId: yup.string().required("Role is required*"),
    companyId: yup.string().required("Company is required*"),
    branchId: yup.string().required("Branch is required*"),
});

interface Iprops {
    singleData: IReqPublishSetting,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [roles, setRoles] = useState<Array<IRolesDropdown>>();
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IReqPublishSetting>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData
    });

    const companyId = watch('companyId');

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadBranches = async (companyId: number) => {
        let queryParam = `company_id=${companyId}`;

        const response = await Fetch(`Dropdown/allBranches`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        const response = await Fetch(`Dropdown/company`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadRoles = async () => {
        const response = await Fetch("Dropdown/rolesForUsersUpdate", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setRoles(_data);
        }
    }

    const saveToDB = async (body: IReqPublishSetting) => {
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("ReqPublishSetting", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            reset(EmptySetting);
            props.setReload(!props.reload);
        }
    }

    useEffect(() => {
        loadCompanies();
        loadRoles();
    }, []);

    useEffect(() => {
        if (companyId) loadBranches(companyId);
        else setBranches(undefined);
    }, [companyId]);

    const onHide = () => {
        props.hideDialog();
        reset(EmptySetting);
    }

    function onSubmit(data: IReqPublishSetting) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: 600 }} header="Add/Edit Req Publish Setting" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={2} required label="Company" control={control} name="companyId" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" error={errors.companyId?.message} />
                <JVDropdown column={2} required label="Branch" control={control} name="branchId" options={branches} optionValue="branch_ID" optionLabel="branchName" placeholder="Select Branch" error={errors.branchId?.message} />
                <JVDropdown column={2} required label="Role" control={control} name="roleId" options={roles} optionValue="role_ID" optionLabel="role_Name" placeholder="Select Role" error={errors.roleId?.message} />
                <JVCheckbox column={2} label="Publish by Skill" showEmptyLabelAtTop control={control} name="publishBySkill" />
                <JVCheckbox column={2} label="Publish in Branch" showEmptyLabelAtTop control={control} name="publishInBranch" />
                <JVCheckbox column={2} label="Publish in Company" showEmptyLabelAtTop control={control} name="publishInCompany" />
                <JVCheckbox column={2} label="Publish Globally" showEmptyLabelAtTop control={control} name="publishGlobally" />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>

            </form>
        </Dialog>
    );
}
